export const applyReceiverToForm = ({ form, fieldName, record }) => {
  const tempForm = form.getFieldsValue();

  if (fieldName) {
    tempForm[fieldName].recipientName = record.firstName;
    tempForm[fieldName].recipientSurname = record.lastName;
    tempForm[fieldName].recipientPhone = record.phone;
    tempForm[fieldName].recipientCity = record.address?.city?.name;
    tempForm[fieldName].recipientTown = record.address?.town?.name;
    tempForm[fieldName].recipientDistrict = record.address?.district?.name;
    tempForm[fieldName].recipientAddressLine = record.address?.addressLine;
  } else {
    tempForm.firstName = record.firstName;
    tempForm.lastName = record.lastName;
    tempForm.phone = record.phone;
    tempForm.city = record.address?.city?.name;
    tempForm.town = record.address?.town?.name;
    tempForm.district = record.address?.district?.name;
    tempForm.addressLine = record.address?.addressLine;
  }

  form.setFieldsValue(tempForm);
};
